export default "<div class=\"spinnerbox\"><img src=\"assets/spinner.svg\"></div>\n"